import React from "react";
import "./style.css";

const CardsGroup = ({ data=[], color="white", colors=[] }) => {
  return (
    ((data && data.length) ? <section className="cards-group widget-group">
      {data.map((d, i) => {
        return (
          <div key={i} className="card">
            <h1 className="cards-group-text1" style={{color: colors[(i%colors.length)] || color}}>{d.heading}</h1>
            <h2 className="cards-group-text2" >{d.desc}</h2>
          </div>
        );
      })}
    </section> : null)
  );
};

export default CardsGroup;
